export const FILTER_BY_AUTHOR = "blogs/fileterByAuthor";
export const FILTER_BY_CATEGORY = "blogs/filterByCategory";
export const FILTER_BY_SEARCH = "blogs/filterBySearch";
